export const MACRO_COLOR_POLICY_V1 = Object.freeze({
  profile: 'playcast-visual-itp-v3' as const,
  recipe: 'macro-color-itp-v1' as const,
  nuisancePreset: 'macro-color-nuisance-v2' as const,
  scoringRule: 'itp-required-envelope-v1' as const,
  comparisonWhiteNits: 203 as const,
  q20Scale: 1_048_576 as const,
  q12Scale: 4_096 as const,
  canonicalComponentLimit: 8 * 1_048_576,
  maximumSide: 16_384 as const,
  maximumPixels: 16_777_216 as const,
  maximumBytes: 201_326_624 as const,
  colorDenominator: 422_212_465_065_984 as const,
  energyDenominator: 201_326_592 as const,
  previewRecipe: 'macro-preview-bt2390-srgb-v1' as const,
  rounding: 'half-away-from-zero' as const,
});

export const MACRO_COLOR_RECIPE_DIGEST = 'f136c2ddd552e13a761ce74e333e2c717babe0892a094a14eb1ab7c0751bcfd3' as const;
